var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3069 1.8C8.96634 2.76145 8.90505 3.79969 9.13011 4.79453C9.35518 5.78937 9.8574 6.70013 10.5786 7.42137C11.2999 8.1426 12.2106 8.64482 13.2055 8.86989C14.2003 9.09495 15.2386 9.03366 16.2 8.6931V17.1C16.2 17.3387 16.1052 17.5676 15.9364 17.7364C15.7676 17.9052 15.5387 18 15.3 18H0.9C0.661305 18 0.432387 17.9052 0.263604 17.7364C0.0948211 17.5676 0 17.3387 0 17.1V2.7C0 2.46131 0.0948211 2.23239 0.263604 2.0636C0.432387 1.89482 0.661305 1.8 0.9 1.8H9.3069ZM14.4 7.2C13.4452 7.2 12.5295 6.82072 11.8544 6.14558C11.1793 5.47045 10.8 4.55478 10.8 3.6C10.8 2.64522 11.1793 1.72955 11.8544 1.05442C12.5295 0.379285 13.4452 0 14.4 0C15.3548 0 16.2705 0.379285 16.9456 1.05442C17.6207 1.72955 18 2.64522 18 3.6C18 4.55478 17.6207 5.47045 16.9456 6.14558C16.2705 6.82072 15.3548 7.2 14.4 7.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.e23f8cf6.svg";
export { ForwardRef as ReactComponent };